import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

function titleWithSku(product) {
  return `${product.get("productSku")} - ${product.get("productTitle")}`;
}

function convertTitles(products) {
  return products.map(x => {
    return x.set("title", titleWithSku(x))
  });
}

class AddProductToOrderForm extends Component {

  render() {
    let {errors, handleSubmit, submit, products, groups, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    let productsWithSkuTitle = convertTitles(products);
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Product"
              name="productSku"
              component={DropDownInputField}
              data={productsWithSkuTitle}
              groups={groups}
              valueKey="productSku"  
              titleKey="title" 
              showBlank={true}
              useGroups={true}
              groupKey="type"
              serverError={this.props.errors.productSku}
              />
            <Field 
              label="Quantity"
              name="quantity"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.quantity}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AddProductToOrderForm"
})(AddProductToOrderForm);

export default ReduxForm;